import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { useNavigate } from "react-router-dom";
import CoverLayout from "../components/CoverLayout";

function InvalidInvitation() {
  const navigate = useNavigate();

  return (
    <CoverLayout coverHeight="40vh">
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="secondary"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Invalid Invitation
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          Your invite is no longer valid. Contact your admin for more details.
          <MDBox mt={4} mb={1}>
            <MDButton
              variant="gradient"
              color="newColor"
              fullWidth
              onClick={() => navigate("/sign-in")}
            >
              Back to Sign in
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default InvalidInvitation;
